module.exports = "<div class=\"panel-group\" id=\"accordion\">\n    <ng-content></ng-content>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/common/components/collapse/collapse.form.wrapper.template.html
// module id = 957
// module chunks = 0